/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal, Cameron Hassan
 */

import React, { useEffect } from "react"
import { MomentRow } from "trux/dist/organisms"
import { traceIdPlusUrl } from "../../util/links"
import * as links from "../../util/links"

export default function EventItem(props) {
    // Suffix Type
    let highlightPlayer = null
    if (props.currentPlaylist) {
        if (props.currentPlaylist?.id.match(/^player-highlights/i)) {
            highlightPlayer = props.currentPlaylist.scope.player.user.user_id
        }
    }

    function onStarPressed(momentInTraceId, eventNumber) {
        if (momentInTraceId) {
            window.location.href = traceIdPlusUrl(
                momentInTraceId.profile_hash_key,
                momentInTraceId.collection_hash_key,
                momentInTraceId.playlist_clip_id
            )
        } else {
            let camera = props.currentCamera
            let en = eventNumber
            if (camera && camera !== "all" && camera !== "tracecam") {
                en = `${eventNumber}:${camera}`
            }
            let url = `/${props.teamName}/games/${props.gameId}/${props.playlistId}/${en}/save/profile`
            props.history.push(url)
        }
    }

    function onUserPressed(moment) {
        onRowPressed(moment)
    }

    function onTagPressed(moment) {}

    function onRowPressed(moment) {
        let url = ""
        let selectedCamera = props.selectedCamera
        let eventProp =
            selectedCamera && selectedCamera !== "all"
                ? `${moment.event_number}:${selectedCamera}`
                : moment.event_number
        if (moment) {
            url = links.gameUrl(
                props.teamName,
                props.playlistId,
                props.gameId,
                eventProp
            )
        } else {
            url = links.gameUrl(props.teamName, props.playlistId, props.gameId)
        }

        if (window.innerWidth >= 541 && window.innerHeight > 541) {
            // keep panel open on mobile landscape
            url += "/moments"
        }

        if (props.playlistId !== "qa") {
            props.history.push(url)
        }
    }

    let currentEvent = props.event ? { ...props.event } : null

    // Let's replace the event with the currentSource if we need to
    if (props.selectedCamera && props.event) {
        let matchingEvent = props.event.sources?.find((source) => {
            return source.meta.camera.name === props.selectedCamera
        })
        if (matchingEvent) {
            currentEvent = { ...matchingEvent }
            currentEvent.full_game_time = props.event.full_game_time
        }
    }

    let copiedEvent = JSON.parse(JSON.stringify(currentEvent))
    copiedEvent.event_number = props.event.event_number

    // If we're viewing a different source than default, let's copy that source's tags
    // onto the moment b/c MomentRow uses the tags on the moment itself to generate
    // tags rather than the tags prop

    const tags = currentEvent ? currentEvent.tags : props.event.tags
    if (currentEvent !== props.event) {
        copiedEvent.tags = tags
        copiedEvent.display_number = props.event.display_number
    }

    let players = []
    for (let tn of props.event.meta.trace_numbers) {
        for (let plyr of props.players) {
            // eslint-disable-next-line eqeqeq
            if (tn == plyr.trace_number) {
                players.push({
                    ...plyr,
                    imageUrl: `https://lapi.traceup.com/tracebot-${process.env.REACT_APP_TRACE_ENV}/avatars?user=${plyr.user.user_id}`,
                })
            }
        }
    }
    let title = null
    if (["full-game", "coach-notes"].includes(props.currentPlaylist.id)) {
        title = props.event.title
    }

    const momentInTraceId = props.momentsInTraceId.find(
        (moment) => moment.game_clip_id === copiedEvent.game_clip_id
    )

    const eventNumberWithoutCamera = props.eventNumber
        ? props.eventNumber.split(":")[0]
        : null
    const isExpanded = eventNumberWithoutCamera.startsWith("C")
        ? props.event.game_clip_id ===
          parseInt(eventNumberWithoutCamera.replace("C", ""))
        : parseInt(props.event.event_number) ===
          parseInt(eventNumberWithoutCamera)

    return (
        <MomentRow
            trkAction="Moment Row Pressed"
            title={title}
            key={`event-${props.event.game_clip_id}`}
            startTime={props.event.full_game_time}
            moment={copiedEvent}
            players={players}
            expanded={isExpanded}
            tags={props.event.tags}
            onClick={onRowPressed}
            starClick={() =>
                onStarPressed(momentInTraceId, props.event.event_number)
            }
            userClick={onUserPressed}
            tagClick={onTagPressed}
            spotlight={props.spotlightEnabled && props.event.has_spotlight}
            highlightPlayer={highlightPlayer}
            homeColor={props.homeTeamColor}
            awayColor={props.awayTeamColor}
            momentInTraceId={momentInTraceId}
        />
    )
}
